import * as React from 'react';
import S from './MobileNavigation.styles';
import SH from '../Header.styles';
import SvgLogo from '@img/logo.svg';
import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { Theme } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
// TODO: ADD SEARCH CRITERIA AND OPEN SEARCH SEPERATE FROM MENU
const MobileNavigation = ({ activePage = '', isOpen, links, headerCta, setShowNav, searchTerm, setSearchTerm, handleRedirect, }) => {
    const [stack, setStack] = React.useState([]);
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (isOpen) {
            setStack([]);
        }
    }, [isOpen]);
    // Render top level navigation...
    if (stack.length === 0) {
        return renderDefault();
    }
    // ...or current level.
    return renderLevel(stack[stack.length - 1]);
    /**
     * Render the top-level layout.
     * @returns
     */
    function renderDefault() {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "aria-hidden": !isOpen, "aria-label": "Main Navigation" },
            React.createElement(S.MockHeader, null,
                React.createElement(SH.LogoWrapper, null,
                    React.createElement(SH.LogoLink, { href: "/" },
                        React.createElement(SvgLogo, null))),
                React.createElement(SH.TopArea, null,
                    React.createElement(SH.TopGrid, { "data-menu-open": isOpen },
                        React.createElement(SH.SecondaryLogo, { "data-indent": false },
                            React.createElement(SH.LogoLink, { href: "/" },
                                React.createElement(SH.SecondaryLogoImg, { src: "/img/BSA-logo-edit.png", alt: "Secondary Logo" }))),
                        React.createElement(SH.BurgerBtn, { type: "button", onClick: () => setShowNav(!isOpen) },
                            React.createElement("div", null, getSystemIcon(isOpen ? SystemIcon.Close : SystemIcon.Burger)))))),
            React.createElement(S.SearchBoxContainer, { id: "nav-search" },
                React.createElement(SH.SearchBox, null,
                    React.createElement(SH.SearchInput, { type: "search", id: "search", value: searchTerm, onChange: (event) => {
                            setSearchTerm(event.target.value);
                        }, placeholder: "Search" }),
                    React.createElement(SH.SearchButton, { type: "submit", "aria-label": "Search", onClick: handleRedirect }, getSystemIcon(SystemIcon.Search)))),
            React.createElement(S.ListArea, null,
                React.createElement(S.List, null, links.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.NavLink, { href: item.url, tabIndex: isOpen ? 0 : -1, target: item.target, "data-active-page": activePage === item.id, onClick: (event) => {
                            if (item.children && item.children.length > 0) {
                                event.preventDefault();
                                push(item);
                            }
                        } },
                        React.createElement(S.Text, null, item.text),
                        item.children?.length && item.children?.length > 0 ? React.createElement(S.Arrow, null) : undefined)))))),
            React.createElement(S.BaseCta, null,
                React.createElement(LinkButton, { buttonType: Theme.Orange, href: headerCta?.url, icon: SystemIcon.Leader, target: headerCta?.target }, headerCta?.text))));
    }
    /**
     * Render the layout for the current active item (last in stack).
     * @returns
     */
    function renderLevel(activeItem) {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "data-has-grandchildren": activeItem.children && activeItem.children?.filter((item) => item.children).length > 0
                ? true
                : false },
            React.createElement(S.MockHeader, null,
                React.createElement(SH.LogoWrapper, null,
                    React.createElement(SH.LogoLink, { href: "/" },
                        React.createElement(SvgLogo, null))),
                React.createElement(SH.TopArea, null,
                    React.createElement(SH.TopGrid, { "data-menu-open": isOpen },
                        React.createElement(SH.SecondaryLogo, { "data-indent": false },
                            React.createElement(SH.LogoLink, { href: "/" },
                                React.createElement(SH.SecondaryLogoImg, { src: "/img/BSA-logo-edit.png", alt: "Secondary Logo" }))),
                        React.createElement(SH.BurgerBtn, { type: "button", onClick: () => setShowNav(!isOpen) },
                            React.createElement("div", null, getSystemIcon(isOpen ? SystemIcon.Close : SystemIcon.Burger)))))),
            React.createElement(S.SearchBoxContainer, { id: "nav-search" },
                React.createElement(SH.SearchBox, null,
                    React.createElement(SH.SearchInput, { type: "search", id: "search", placeholder: "Search" }),
                    React.createElement(SH.SearchButton, { type: "submit", "aria-label": "Search" }, getSystemIcon(SystemIcon.Search)))),
            React.createElement(S.Header, null,
                React.createElement(S.Back, { onClick: (event) => {
                        event.preventDefault();
                        pop();
                    } },
                    React.createElement(S.Arrow, null),
                    React.createElement("span", null, "Back")),
                activeItem.url && (React.createElement(S.ParentLink, { "data-show-parent": stack.length > 2, href: activeItem.url }, `View ${activeItem.text}`))),
            React.createElement(S.ListArea, null,
                React.createElement(S.List, { "data-first-level": stack.length === 1, "data-is-simple": stack.length > 2 },
                    React.createElement(S.Item, { key: activeItem.id },
                        React.createElement(S.Link, { href: activeItem.url, target: activeItem.target }, activeItem.text)),
                    activeItem.featured && activeItem.featured.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(S.Link, { "data-active-page": activePage === item.id, ...(item.url ? { href: item.url, target: item.target } : { as: 'button' }) },
                            React.createElement(S.ContentArea, null,
                                React.createElement(S.TitleArea, null,
                                    React.createElement(S.Text, null,
                                        React.createElement("span", null, item.text)))))))),
                    activeItem.children &&
                        activeItem.children.map((item) => (React.createElement(S.Item, { key: item.id },
                            React.createElement(S.Link, { "data-active-page": activePage === item.id, onClick: (event) => {
                                    if (item.children && item.children.length > 0) {
                                        event.preventDefault();
                                        item && push(item);
                                    }
                                }, ...(item.url ? { href: item.url, target: item.target } : { as: 'button' }) },
                                React.createElement(S.ContentArea, null,
                                    React.createElement(S.TitleArea, null,
                                        React.createElement(S.Text, null,
                                            React.createElement("span", null, item.text)),
                                        item.children?.length && item.children?.length > 0 ? (React.createElement(S.Arrow, null)) : (undefined))))))))),
            React.createElement(S.BaseCta, null,
                React.createElement(LinkButton, { buttonType: Theme.Orange, href: headerCta?.url, icon: SystemIcon.Leader, target: headerCta?.target }, headerCta?.text))));
    }
    /**
     * Push navigation item to stack.
     * @param item
     */
    function push(item) {
        const newStack = [...stack, item];
        setStack(newStack);
    }
    /**
     * Pop last item from stack.
     * @param item
     */
    function pop() {
        const newStack = stack.slice(0, stack.length - 1);
        setStack(newStack);
    }
};
export default MobileNavigation;
